<div class="flex flex-col gap-5">
  @if (miG_UNIDAD_ANALISIS) {
    <div class="grid gap-4 px-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
      <div
        class="bg-[--brand-azul-primario] w-full rounded-lg col-span-full py-1 flex justify-center items-center text-base font-medium"
      >
        {{ 'general-pages.analysis.unitData' | translate }}
      </div>
      <div class="col-span-full">
        {{ 'general-pages.analysis.car' | translate }} : {{ miG_UNIDAD_ANALISIS.auto }}
      </div>
      <div>{{ 'general-pages.analysis.plan' | translate }} : {{ miG_UNIDAD_ANALISIS.desPlan }}</div>
      <div>
        {{ 'general-pages.analysis.serialNumber' | translate }} : {{ miG_UNIDAD_ANALISIS.numSerie }}
      </div>
      <div>
        {{ 'general-pages.analysis.engineNumber' | translate }} :
        {{ miG_UNIDAD_ANALISIS.numMotor | currency: 'MXN' : 'symbol' : '1.2-2' }}
      </div>
      <div>
        {{ 'general-pages.analysis.initialDisbursement' | translate }} :
        {{ miG_UNIDAD_ANALISIS.desIni1 | currency: 'MXN' : 'symbol' : '1.2-2' }}
      </div>
      <div>
        {{ 'general-pages.analysis.initialDate' | translate }} : {{ miG_UNIDAD_ANALISIS.fecIni }}
      </div>
      <div>{{ 'general-pages.analysis.r0' | translate }} : {{ miG_UNIDAD_ANALISIS.numSerie }}</div>
      <div>
        {{ 'general-pages.analysis.term' | translate }} : {{ miG_UNIDAD_ANALISIS.desPlazo }}
      </div>
      <div>
        {{ 'general-pages.analysis.overdueRents' | translate }} :
        {{ miG_UNIDAD_ANALISIS.rentasVencidas }}
      </div>
    </div>
  }

  @if (dataSource.data.length) {
    <div class="flex flex-col gap-4 px-4">
      <div
        class="bg-[--brand-azul-primario] w-full rounded-lg col-span-full py-1 flex justify-center items-center text-base font-medium"
      >
        {{ 'general-pages.analysis.documentsSummary' | translate }}
      </div>
      <app-table-general-simple
        class="col-span-full"
        [dataSource]="dataSource"
        [headers]="headers"
        [isLoading]="load"
        (idEmitter)="activityfuntion($event)"
      ></app-table-general-simple>
    </div>
  }

  @if (miG_BURO_ANALISIS.length) {
    <div class="grid gap-4 px-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
      <div
        class="bg-[--brand-azul-primario] w-full rounded-lg col-span-full py-1 text-white flex justify-center items-center text-base font-medium"
      >
        {{ 'general-pages.analysis.executiveSummary' | translate }}
      </div>
    </div>
  }
  @if (miG_COMMENTS_ANALISIS) {
    <div class="grid gap-4 px-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
      <div
        class="bg-[--brand-azul-primario] w-full rounded-lg col-span-full py-1 text-white flex justify-center items-center text-base font-medium"
      >
        {{ 'general-pages.analysis.creditSummary' | translate }}
      </div>
    </div>
  }
</div>
